(function() {
  const translations = {
    'en': {
        'Kupuj więcej, oszczędzaj więcej!': 'Buy more, save more!',
        'Oszczędzasz': 'You save ',
        'TOP OFERTA': 'BEST DEAL',
        '2 + 1 Gratis': 'Buy 2 Get 1 Free'
    },
    'de': {
        'Kupuj więcej, oszczędzaj więcej!': 'Mehr kaufen, mehr sparen!',
        'Oszczędzasz': 'Du sparst ',
        'TOP OFERTA': 'TOP ANGEBOT',
        '2 + 1 Gratis': '2 + 1 Gratis'
    },
    'cs': {
        'Buy more, save more!': 'Nakupujte více, ušetřete více!',
        'Save': 'Ušetříte ',
        'TOP OFERTA': 'TOP NABÍDKA',
        '2 + 1 Gratis': '2 + 1 Zdarma',
        "Buy": "Nakoupit "
    },
    'es': {
        'Kupuj więcej, oszczędzaj więcej!': '¡Compra más, ahorra más!',
        'Oszczędzasz': 'Ahorras ',
        'TOP OFERTA': 'MEJOR OFERTA',
        '2 + 1 Gratis': '2 + 1 Gratis'
    },
    'it': {
        'Kupuj więcej, oszczędzaj więcej!': 'Acquista di più, risparmia di più!',
        'Oszczędzasz': 'Risparmi ',
        'TOP OFERTA': 'MIGLIORE OFFERTA',
        '2 + 1 Gratis': '2 + 1 Gratis'
    },
    'fr': {
        'Kupuj więcej, oszczędzaj więcej!': 'Achetez plus, économisez plus !',
        'Oszczędzasz': 'Vous économisez ',
        'TOP OFERTA': 'MEILLEURE OFFRE',
        '2 + 1 Gratis': '2 + 1 Offert'
    }
  };

  const currentLang = document.documentElement.lang.split('-')[0];
  if (currentLang === 'pl' || !translations[currentLang]) return;

  const translateWidget = () => {
    const dictionary = translations[currentLang];
    const elements = document.querySelectorAll('.vtl-ub-vd-widget__content span, .vtl-ub-vd-widget__content div, .vtl-ub-vd-widget__content h3');
    
    elements.forEach(el => {
      const text = el.innerText.trim();
      
      if (dictionary[text]) {
        observer.disconnect(); 
        el.innerText = dictionary[text];
        observer.observe(document.body, { childList: true, subtree: true });
      }
    });
  };

  const observer = new MutationObserver((mutations) => {
    for (let mutation of mutations) {
        if (mutation.addedNodes.length) {
            translateWidget();
            break;
        }
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  translateWidget();
})();